import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FlagImports } from '@core/modules/components/flag/flag.imports';

type TFlagSize = 'large' | 'medium' | 'small' | 'xs' | 'xxs';
type TFlagType = 'circle' | 'square';

@Component({
  selector: 'noda-flag',
  standalone: true,
  templateUrl: './flag.component.html',
  styleUrls: ['./flag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: FlagImports,
})
export class FlagComponent {
  @Input() public country: string;
  @Input() public size: TFlagSize = 'small';
  @Input() public type: TFlagType = 'circle';
  @Input() public styleClass: string;

  @Input('country')
  public set _country(value: string) {
    this.country = value;
    if (value === 'en') this.country = 'gb';
  }
}
